import type { AppNotification } from "types/domain";

/**
 * The `STAFF_CHECKED_IN` / `STAFF_CHECKED_OUT` notification types are
 * misleadingly named — they're created for ALL roles (including a STUDENT
 * self-checkin via face recognition), not just staff. When a STUDENT clicks
 * one of these, they should land on their own attendance-history record
 * rather than the staff-only class-management session page.
 */
const SELF_CHECKIN_NOTIFICATION_TYPES = [
  "STAFF_CHECKED_IN",
  "STAFF_CHECKED_OUT",
];

export function isSelfCheckinNotificationForStudent(
  notif: AppNotification,
  currentUserRole: string | null | undefined
): boolean {
  return (
    currentUserRole === "STUDENT" &&
    SELF_CHECKIN_NOTIFICATION_TYPES.includes(notif.type) &&
    !!notif.session_id
  );
}

export function buildSelfCheckinAttendanceUrl(notif: AppNotification): string {
  return `/user/attendance-history?sessionId=${notif.session_id}`;
}
